import { render, staticRenderFns } from "./FirstNationAssociationsEditor.vue?vue&type=template&id=730d8857&scoped=true"
import script from "./FirstNationAssociationsEditor.vue?vue&type=script&lang=js"
export * from "./FirstNationAssociationsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d8857",
  null
  
)

export default component.exports